module.exports = __webpack_public_path__ + "static/media/buy.670b2165.png";